import { takeLatest, put, select, all } from 'redux-saga/effects';

import {
  briefComponent,
  receiveComponents,
  receiveQuoteItems,
} from 'modules/quotes/quoteItems/data/actions';

import {
  getQuoteItemById,
  getBriefComponentById,
  getComponentsById,
} from 'store/quotes/selectors';

import { BULK_UPDATE_WORKFLOW_STATUS_MODAL_SAVE, save } from './actions';

export default function* root() {
  yield takeLatest(BULK_UPDATE_WORKFLOW_STATUS_MODAL_SAVE, watchSave);
}

function* watchSave(action: ReturnType<typeof save>) {
  const { data } = action.payload;
  const oldQuoteItems: any[] = yield all(
    data.map(({ id }) => select(getQuoteItemById, id)),
  );

  const componentIds = data.flatMap(({ componentWorkflowStatuses }) =>
    Object.keys(componentWorkflowStatuses),
  );
  const oldComponents: any[] = yield select(getComponentsById, componentIds);
  const oldBriefComponents: any[] = yield all(
    componentIds.map((id) => select(getBriefComponentById, id)),
  );

  const newQuoteItems = [];
  const newComponents = [];
  const newBriefComponents = [];

  for (const item of data) {
    const oldItem = oldQuoteItems.find(({ id }) => id === item.id);
    newQuoteItems.push({
      ...oldItem,
      workflowStatus: item.workflowStatus,
      workflowSteps: item.workflowSteps,
    });

    for (const oldComponentId of Object.keys(item.componentWorkflowStatuses)) {
      const newWorkflowStatus =
        item.componentWorkflowStatuses[Number(oldComponentId)];

      const oldBriefComponent = oldBriefComponents.find(
        (component) => component?.id == oldComponentId,
      );
      if (oldBriefComponent) {
        newBriefComponents.push({
          ...oldBriefComponent,
          workflowStatus: newWorkflowStatus,
        });
      }

      const oldComponent = oldComponents.find(
        (component) => component?.id == oldComponentId,
      );
      if (oldComponent) {
        newComponents.push({
          ...oldComponent,
          workflowStatus: newWorkflowStatus,
        });
      }
    }
  }

  yield put(receiveQuoteItems(newQuoteItems));
  yield put(
    briefComponent.receiveMultiple({ briefComponents: newBriefComponents }),
  );
  yield put(receiveComponents(newComponents));
}
